import React from 'react';

import { Chip } from '@material-ui/core';
import styled from 'styled-components';

import { SEARCH_TAG_TYPES } from 'constants/ProjectConstants';

export default function MentionEntryComponent({
  mention,
  theme,
  searchValue, // eslint-disable-line no-unused-vars
  isFocused, // eslint-disable-line no-unused-vars
  ...parentProps
}) {
  const { tagType, employee, group } = mention;

  const isEmployeeTag = tagType === SEARCH_TAG_TYPES.employee;
  if (isFocused) {
    parentProps.className += ' mentionSuggestionEntryFocused';
  }
  return (
    <div {...parentProps} key={`${employee.id}-mention-suggestions`}>
      <div
        style={{ width: '100%' }}
        className={`${theme.mentionSuggestionsEntryContainer} ${!isEmployeeTag && theme.demographicsContainer}`}
      >
        <div className={theme.mentionSuggestionsEntryContainerLeft}>
          {isEmployeeTag ? (
            <img
              src={employee.getProfileImage()}
              className={theme.mentionSuggestionsEntryAvatar}
              role="presentation"
              alt="Profile"
            />
          ) : (
            `@${group.displayName}`
          )}
        </div>

        <div className={theme.mentionSuggestionsEntryContainerRight}>
          <div className={theme.mentionSuggestionsEntryText}>
            {isEmployeeTag ? (
              <span>{employee.fullName}</span>
            ) : (
              <>{/* <StyledChip size="small" label={tagType} variant="outlined" /> */}</>
            )}
          </div>

          {isEmployeeTag && <div className={theme.mentionSuggestionsEntryTitle} />}
        </div>
      </div>
    </div>
  );
}

const StyledChip = styled(Chip)`
  margin-left: 0.5rem;
`;
